<template>
    <b-container id="portal" class="portal portal-confirmation mt-5" v-if="portal && confirmation">
        <b-card>
            <b-row class="mt-3">
                <b-col class="text-center" v-if="portal.confirmationMessage" v-html="portal.confirmationMessage">
                </b-col>
                <b-col class="text-center" v-else>
                    <div>Thanks for your interest in {{portal.client.name}}.</div>
                    <div>Your opportunity has been successfully submitted. You should receive an email confirmation within the next few minutes.</div>
                    <div>One of our Innovation and Licensing Professionals will contact you as soon as possible.</div>
                    <div>Please save the reference below in case of a problem or question</div>
                </b-col>
            </b-row>

            <div class="text-center submissionCode" v-if="statusCode">{{statusCode.message}}</div>

            <b-row class="mt-3">
                <b-col class="text-center">
                    <b-button v-if="published" squared variant="primary" class="new-submit-btn text-uppercase"
                              :to="{ name: 'PortalSubmission', params: { name: portal.name } }">
                        {{portal.newSubmissionButton ? portal.newSubmissionButton : 'New Submission'}}
                    </b-button>
                    <b-button v-if="!published" squared variant="primary" class="new-submit-btn text-uppercase"
                              :to="{ name: 'DraftSubmission', params: { name: portal.name } }">
                        {{portal.newSubmissionButton ? portal.newSubmissionButton : 'New Submission'}}
                    </b-button>
                </b-col>
            </b-row>
        </b-card>
    </b-container>
</template>

<script>
    export default {
        name: "Confirmation",
        props: {
            portal: Object,
            statusCode: Object,
            published: Boolean
        },
        data() {
            return {
                confirmation: true
            }
        },
    }
</script>

<style lang="scss" scoped>
    .submissionCode {
        color: var(--primary);
        font-size: 30px;
        font-weight: 700;
        margin: 20px 0 20px;
    }
</style>